import { AllSarConst } from "src/app/core/constants/all-sar.constant";
import { DataBindingDirective } from "@progress/kendo-angular-grid";
import { HttpClient } from "@angular/common/http";
import { HttpUtilityService } from "src/app/core/services/http.utility.service";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AllSarService{
    constructor(private http: HttpClient, public httpUtilityService: HttpUtilityService) {
    }

    getAllRequestsData(data : any): Observable<DataBindingDirective> {
        return this.httpUtilityService.post<DataBindingDirective>(AllSarConst.apiName + AllSarConst.getAllRequests, data,);
    }

    getAllRequestsForExport(data : any): Observable<DataBindingDirective> {
        return this.httpUtilityService.post<DataBindingDirective>(AllSarConst.apiName + AllSarConst.getAllRequestsForExport, data,);
    }

    // getAllRequests(data: any) {
    //     return this.httpUtilityService.post(AllSarConst.apiName + AllSarConst.getAllRequests, data);
    //   }
}
